<div class="keyboard-container">
  <!-- Top row: Q to P (10 letters) -->
  <div class="keyboard-row keyboard-row-top">
    @for (letter of letters[0]; track letter) {
      <ion-button
        fill="outline"
        (click)="onLetterClick(letter)"
        [disabled]="disabled || value.length >= maxLength"
        class="key-button"
      >
        {{ letter }}
      </ion-button>
    }
  </div>
  <!-- Middle row: A to L (9 letters) -->
  <div class="keyboard-row keyboard-row-middle">
    @for (letter of letters[1]; track letter) {
      <ion-button
        fill="outline"
        (click)="onLetterClick(letter)"
        [disabled]="disabled || value.length >= maxLength"
        class="key-button"
      >
        {{ letter }}
      </ion-button>
    }
  </div>
  <!-- Bottom row: Z to M (7 letters) + Backspace -->
  <div class="keyboard-row keyboard-row-bottom">
    @for (letter of letters[2]; track letter) {
      <ion-button
        fill="outline"
        (click)="onLetterClick(letter)"
        [disabled]="disabled || value.length >= maxLength"
        class="key-button"
      >
        {{ letter }}
      </ion-button>
    }
    <ion-button
      fill="outline"
      color="medium"
      (click)="onBackspaceClick()"
      [disabled]="disabled || value.length === 0"
      class="key-button key-button-backspace"
    >
      <ion-icon name="backspace" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
  <!-- Space bar row: spans width of bottom row (7 letters + backspace = 8 keys) -->
  <div class="keyboard-row keyboard-row-space">
    <ion-button
      fill="outline"
      (click)="onSpaceClick()"
      [disabled]="disabled || isSpaceDisabled"
      class="key-button key-button-space"
    >
      Space
    </ion-button>
  </div>
</div>
